import http from './http';
import config from '~/config';

const withErrorHandling = async (request) =>{
    try {
        let response = await request();

        if (response.errored) {
            throw new Error(response.error);
        }

        return response;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const create = async (data) => {
    try {
        const response = await http.post(
            `${config.urls.base}/policySearchRequest`,
            data
        );

        if (response.errored) {
            throw new Error(response.error);
        }

        return {
            ...response,
            _data: JSON.parse(response._data)
        };
        
    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const addAttachment = async (requestId, document) => {
    const upload = {
        name: document.fileName,
        fileSize: document.fileSize,
        typeId: document.typeId,
        uuid: document.cloudFileName,
        path: document.cloudStoragePath,
        extension: document.fileExtension
    };

    const uri = `${config.urls.base}/policySearchRequest/${requestId}/attachments`;
    
    return withErrorHandling(() => http.post(uri, upload));
};

export const deleteAttachment = async (requestId) => {
    const uri = `${config.urls.base}/policySearchRequest/${requestId}/attachments`;
    
    return withErrorHandling(() => http.del(uri));
};

export const deletePolicySearchAttachment = async (documentId) => {
    const uri = `${config.urls.base}/policySearchRequestAttachments/${documentId}`;

    return withErrorHandling(() => http.del(uri));
};

export const getById = async (requestId) => {
    const uri = `${config.urls.base}/policySearchRequest/${requestId}`;

    return withErrorHandling(() => http.get(uri));
};

export const getAll = (backDate = null,  offset = 0, size = 10, hasFilters = false, filters = {}) => {
    const url = `${config.urls.base}/policySearchRequest`;

    return backDate == null
        ? withErrorHandling(() => http.get(url))
        : withErrorHandling(() => http.get2(url, { backDate, offset, size, hasFilters, filters: JSON.stringify(filters) }));
};

export const getAllForExport = (startDate, endDate,  offset = 0, size = 10) => {
    const url = `${config.urls.base}/policySearchRequest/export`;

    return withErrorHandling(() => http.get2(url, { startDate, endDate, offset, size }));
};

export const getExternalSystems = async () => {
    const url = `${config.urls.base}/searchSystem`;

    return withErrorHandling(() => http.get(url));
};

export const runSearch = async (id, data = {}) => {
    const url = `${config.urls.base}/policySearchRequest/${id}/search`;

    return withErrorHandling(() => http.put(url, data));
};

export const getSearchResults = async (requestId) => {
    const uri = `${config.urls.base}/policySearchRequest/${requestId}/search`;

    return withErrorHandling(() => http.get(uri));
};

export const completeSearch = async (id, data = {}) => {
    const uri = `${config.urls.base}/policySearchRequest/${id}`;

    return withErrorHandling(() => http.patch(uri, data));
};

export const softDelete = async (id) => {
    const uri = `${config.urls.base}/policySearchRequest/${id}`;

    return http.del(uri);
};

export const sendNewRequestEmail = async (requestId) => {
    const uri = `${config.urls.base}/policySearchRequest/sendNewRequestEmail/${requestId}`;

    return withErrorHandling(() => http.get(uri));
};

export default {
    create,
    addAttachment,
    deleteAttachment,
    getAll,
    getAllForExport,
    getById,
    getExternalSystems,
    runSearch,
    getSearchResults,
    completeSearch,
    softDelete,
    sendNewRequestEmail,
    deletePolicySearchAttachment
};